const HEIF_BRANDS = [
  'heic',
  'heix',
  'heim',
  'heis',
  'hevc',
  'hevm',
  'hevs',
  'heif'
];

const HEIF_EXTENSIONS = ['.heic', '.heif', '.heics', '.heifs'];

export const IMAGE_INPUT_ACCEPT = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/avif',
  'image/bmp',
  'image/tiff',
  'image/pjpeg',
  '.jpg',
  '.jpeg',
  '.jfif',
  '.pjp',
  '.png',
  '.gif',
  '.webp',
  '.avif',
  '.bmp',
  '.tif',
  '.tiff'
].join(',');

const readFileHeader = (file, length) =>
  new Promise(resolve => {
    try {
      const reader = new FileReader();
      reader.onload = () => resolve(new Uint8Array(reader.result));
      reader.onerror = () => resolve(null);
      reader.readAsArrayBuffer(file.slice(0, length));
    } catch (e) {
      resolve(null);
    }
  });

const hasHeifMime = file => {
  const type = String(file.type).toLowerCase();
  return type.includes('heic') || type.includes('heif');
};

const hasHeifExtension = file => {
  const name = String(file.name).toLowerCase();
  return HEIF_EXTENSIONS.some(ext => name.endsWith(ext));
};

const bytesToAscii = (bytes, start, end) => {
  let result = '';
  for (let i = start; i < end && i < bytes.length; i++) {
    result += String.fromCharCode(bytes[i]);
  }
  return result;
};

export const isHeifFile = async file => {
  if (hasHeifMime(file) || hasHeifExtension(file)) {
    return true;
  }

  const header = await readFileHeader(file, 32);
  if (!header || header.length < 12) {
    return false;
  }

  if (bytesToAscii(header, 4, 8) !== 'ftyp') {
    return false;
  }

  const majorBrand = bytesToAscii(header, 8, 12).toLowerCase();
  if (HEIF_BRANDS.includes(majorBrand)) {
    return true;
  }

  for (let offset = 16; offset + 4 <= header.length; offset += 4) {
    const brand = bytesToAscii(header, offset, offset + 4).toLowerCase();
    if (HEIF_BRANDS.includes(brand)) {
      return true;
    }
  }

  return false;
};